import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import YBMeetSDK from '@/lib/YBMeetSDK'
  import VConsole from 'vconsole'
  import { getCurrentInstance, onMounted, ComponentInternalInstance } from 'vue';
  import { loganLog } from "@/utils/log";
  import {isMobile} from '@/utils/util'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  let { appContext } =  getCurrentInstance() as ComponentInternalInstance
  if (!isMobile()) {
      document.getElementsByTagName('html')[0].style.fontSize = '40px'
    }
    window.onresize = () => {
      return (() => {
        if (!isMobile()) {
          document.getElementsByTagName('html')[0].style.fontSize = '40px'
        }
      })()
    }
  onMounted(()=>{
    if(process.env.VUE_APP_ENV == 'dev') new VConsole();
    
    loganLog('[App.vue] onMounted()｜子包sdk访问入口文件类对象YBMeetSDK：===>', YBMeetSDK);

    (window as any).YBMeetSDK = new YBMeetSDK({
      appId: '',
      appSecret: '', 
      mode: process.env.VUE_APP_ENV === 'prod' ? 'pro' : process.env.VUE_APP_ENV // pro , dev , test
    });
    
    // 全局挂在YBMeetSDK实例
    appContext.config.globalProperties.$YBMeetSDK = (window as any).YBMeetSDK

    loganLog('[App.vue] onMounted()｜YBMeetSDK实例对象：===>', (window as any).YBMeetSDK);
  })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})